import { css, cx } from "@emotion/css"

import { Arc } from "@visx/shape"
import { Group } from "@visx/group"
import { LinearGradient } from "@visx/gradient"
import { compactShort } from "routes/Base/Dashboards/RevenueDashboard/helpers/formatters"
import { scaleOrdinal } from "@visx/scale"

const styles = {
  root: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
  `,
  arc: css`
    transform: rotate(-90deg);
  `,
}
const stylesWidgetStats = {
  stats: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-center;
    align-items: flex-center;
    padding: 0;
    color: white;
    position: absolute;
    bottom: -20px;
  `,
  value: css`
    width: 160px;
    text-align: center;
    color: var(--white);
    font-weight: 900;
    text-align: center;
    flex-direction: center;
    font-size: 30px;
  `,

  legend: css`
    padding: var(--spacing-xxs) 0 0;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  `,
  title: css`
    color: var(--white);
    font-size: 13px;
    font-weight: 300;
  `,

  number: css`
    font-size: 12px;
    font-weight: 400;
  `,
  left: css`
    color: var(--white);
    font-size: 17px;
    font-weight: 900;
  `,
}
interface propsTypes {
  percentage: number
  className: string
  title?: string
}
export function SemiCircularProgressWithLabel(props: propsTypes) {
  const { title } = props
  const white = "var(--other-yellow)"
  const green = "var(--primary-main-green)"
  const red = "red"
  const color = scaleOrdinal({
    domain: [0],
    range: ["url(#whitegreen)"],
  })
  const color2 = scaleOrdinal({
    domain: [0],
    range: ["url(#redwhite)"],
  })

  return (
    <div className={styles.root}>
      <svg height={100} width={200}>
        <LinearGradient
          id="whitegreen"
          from={white}
          to={green}
          vertical={false}
        />
        <LinearGradient id="redwhite" from={red} to={white} vertical={false} />
        <Group top={200 / 2} left={100}>
          <g>
            {props?.percentage === null || props?.percentage === null ? (
              <Arc
                className={styles.arc}
                startAngle={0}
                endAngle={Math.PI}
                innerRadius={60}
                outerRadius={70}
                fill={"#0d0d0d"}
              />
            ) : props?.percentage >= 0 ? (
              <>
                <Arc
                  className={styles.arc}
                  startAngle={0}
                  endAngle={Math.PI}
                  innerRadius={60}
                  outerRadius={70}
                  fill={"#0d0d0d"}
                />
                <Arc
                  className={styles.arc}
                  startAngle={0}
                  endAngle={(props?.percentage / 200) * Math.PI}
                  innerRadius={60}
                  outerRadius={70}
                  fill={color2(0)}
                />
                <Arc
                  className={styles.arc}
                  startAngle={(props?.percentage / 205) * Math.PI}
                  endAngle={Math.PI / 2 + props?.percentage / 65}
                  innerRadius={60}
                  outerRadius={70}
                  fill={color(0)}
                />
              </>
            ) : (
              <>
                <Arc
                  className={styles.arc}
                  startAngle={0}
                  endAngle={Math.PI}
                  innerRadius={60}
                  outerRadius={70}
                  fill={"#0d0d0d"}
                />
                <Arc
                  className={styles.arc}
                  startAngle={0}
                  endAngle={
                    ((1 - Math.abs(props?.percentage) / 100) * Math.PI) / 4
                  }
                  innerRadius={60}
                  outerRadius={70}
                  fill={color2(0)}
                />
                <Arc
                  className={styles.arc}
                  startAngle={
                    ((1 - Math.abs(props?.percentage) / 100) * Math.PI) / 4
                  }
                  endAngle={
                    ((1 - Math.abs(props?.percentage) / 100) * Math.PI) / 2
                  }
                  innerRadius={60}
                  outerRadius={70}
                  fill={color(0)}
                />
              </>
            )}
          </g>
        </Group>
      </svg>

      <div className={stylesWidgetStats.stats}>
        <span className={cx("HeadingH3Black", stylesWidgetStats.value)}>
          {props.percentage !== -100
            ? `${compactShort(props.percentage)}`
            : "-"}
        </span>
        <div className={stylesWidgetStats.legend}>
          <span className={cx("HeadingH5bBold", stylesWidgetStats.number)}>
            -100
          </span>
          <span className={cx("HeadingH5bBold", stylesWidgetStats.title)}>
            {title}
          </span>
          <span className={cx("HeadingH5bBold", stylesWidgetStats.number)}>
            100
          </span>
        </div>
      </div>
    </div>
  )
}
